<template>
	<CharacteristicSelectInline
		:value="value"
		:characteristic-type="meta.pilotLicenseType"
		:characteristic-items="meta.pilotLicense"
		initial-show-all
		show-multiple-hint
		:nothing-allowed="{
			text: 'Kein Flugschein notwendig'
		}"
		:label-type="labelTypeJobProfile"
		@input="$emit('input', $event)"
	/>
</template>

<script>
import CharacteristicSelectInline from "@/vue/characteristic/SelectInline";
import {JOB_PROFILE} from "@/helper/characteristic/Label";

export default {

	components: {
		CharacteristicSelectInline,
	},

	props: {
		value: {
			type: Array,
			required: false,
		},
		meta: {
			type: Object,
			required: true,
		},
	},

	computed: {
		labelTypeJobProfile ()
		{
			return JOB_PROFILE;
		}
	}
}
</script>
